module.exports = __webpack_public_path__ + "static/img/cdb3.f5c3dcbe.png";